import React, { Component, PropTypes } from 'react';
import classnames from 'classnames'

export default class Content extends Component {
  render() {

    let { className, innerClassName, fitToBox, children, ...props} = this.props;

    className = classnames("App-content", className);
    innerClassName = classnames("App-content-inner", innerClassName);

    return (
      <div className={className} {...props}>
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-lg-10 col-lg-push-1 ">
              <div className={innerClassName}>
                {fitToBox ?
                  children :
                  <div className="row">
                    <div className="col-xs-12 col-sm-10 col-sm-push-1 ">
                      {children}
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

Content.propTypes = {
  fitToBox: PropTypes.bool,
  innerClassName: PropTypes.string
};


Content.defaultProps = {
  fitToBox: false
};


// WEBPACK FOOTER //
// ./src/components/Content.js